<template>
  <div class="flex">
    <DateInput
      :rules="rules"
      :label="label || dateLabel"
      @update="val => (dateForInput = val)"
      :placeholder="placeholder"
      :date="dateForInput"
      :icon="icon"
    ></DateInput>
    <span class="pr-4"></span>
    <TimeInput
      :rules="rules"
      :label="label || timeLabel"
      @update="val => (timeForInput = val)"
      :placeholder="placeholder"
      :date="timeForInput"
      :icon="icon"
    ></TimeInput>
  </div>
</template>

<script>
import DateInput from "./DateInput";
import TimeInput from "./TimeInput";
import moment from "moment";
export default {
  name: "dataTimeInput",
  components: {
    DateInput,
    TimeInput
  },
  props: {
    date: {
      type: String
    },
    label: {
      type: String,
      default: ""
    },
    dateLabel: {
      type: String,
      default: ""
    },
    timeLabel: {
      type: String,
      default: ""
    },

    placeholder: {
      type: String,
      default: ""
    },
    icon: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: function() {
        return [];
      }
    },
    defaultTime: {
      type: String,
      default: "00:00"
    }
  },
  data: () => ({}),

  computed: {
    localDate() {
      let date = this.date && this.date.replace(/\s/g, "");
      if (date) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").local();
      }
      return "";
    },
    dateForInput: {
      get() {
        if (this.localDate) {
          return this.localDate.format("YYYY-MM-DD");
        }
        return undefined;
      },
      set(val) {
        this.updateDateTime(val, this.timeForInput);
      }
    },

    timeForInput: {
      get() {
        if (this.localDate) {
          return this.localDate.format("HH:mm");
        }
        return undefined;
      },
      set(val) {
        this.updateDateTime(this.dateForInput, val);
      }
    }
  },
  methods: {
    updateDateTime(date, time) {
      if (date) {
        this.$emit(
          "update",
          moment(
            `${date || moment().format("YYYY-MM-DD")} ${time ||
              this.defaultTime}`
          ).format()
        );
      } else {
        this.$emit("update", "");
      }

      this.$nextTick(() => {
        this.$forceUpdate();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
</style>
